import { Col, Row, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

import { useDirection } from "@/hooks";

type TProps = {
  label: string;
  value: ReactNode;
};

function UserItem({ label, value }: TProps) {
  const dir = useDirection();
  return (
    <Row style={{ width: "100%", marginTop: "8px" }}>
      <Col>
        <Typography.Text>{label}:</Typography.Text>
      </Col>
      <Col
        style={dir === "rtl" ? { marginRight: "auto" } : { marginLeft: "auto" }}
      >
        <Row>
          <Typography.Text
            style={
              dir === "rtl" ? { textAlign: "left" } : { textAlign: "right" }
            }
          >
            {value}
          </Typography.Text>
        </Row>
      </Col>
    </Row>
  );
}

export default observer(UserItem);
